var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, hasMany, belongsTo } from '@ember-data/model';
import { computed, set } from '@ember/object';
import { alias, equal, reads } from '@ember/object/computed';
import { fragment } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import { isNone, isPresent, isEmpty } from '@ember/utils';
import Money from '@square/dashboard-money/models/money';
import { A } from '@ember/array';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { itemSubunitsServiceActiveSubunits } from '@square/dashboard-utilities/utils/item-subunits';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import ItemVariation from '@square/dashboard-items-data/models/connect/item-variation';
import TrackRelationships from 'ember-data-relationship-tracker';
import { ItemTypeConnect } from '@square/dashboard-items-data/utils/item-type-constants';
let _class = (_dec = service(), _dec2 = service(), _dec3 = service(), _dec4 = service(), _dec5 = attr('string', {
  protoEnum: CatalogObjectTypeProto,
  defaultValue: CatalogObjectType.ITEM
}), _dec6 = fragment('connect/item/data'), _dec7 = hasMany('connect/item-variation', {
  async: false
}), _dec8 = belongsTo('connect/event', {
  async: false
}), _dec9 = hasMany('connect/tax', {
  async: false
}), _dec10 = hasMany('connect/image', {
  async: true
}), _dec11 = alias('itemData.name'), _dec12 = alias('itemData.sortName'), _dec13 = alias('itemData.description'), _dec14 = alias('itemData.productType'), _dec15 = alias('itemData.modifierListInfo'), _dec16 = alias('itemData.comboTypeDetails.slots'), _dec17 = alias('itemData.categories'), _dec18 = alias('itemData.isAvailableOnline'), _dec19 = alias('itemData.ecomBuyButtonText'), _dec20 = alias('itemData.ecomAvailable'), _dec21 = alias('itemData.ecomVisibility'), _dec22 = alias('itemData.descriptionHtml'), _dec23 = alias('itemData.descriptionPlaintext'), _dec24 = alias('itemData.kitchenName'), _dec25 = alias('itemData.ecomAllowOrderItemQuantities'), _dec26 = alias('itemData.ecomOrderItemMaxQuantity'), _dec27 = alias('itemData.isArchived'), _dec28 = alias('itemData.isAlcoholic'), _dec29 = alias('itemData.channels'), _dec30 = alias('itemData.requiresSubscriptionToSell'), _dec31 = alias('itemData.customShippingBoxId'), _dec32 = alias('itemData.foodAndBeverageDetails.dietaryPreferences'), _dec33 = alias('itemData.foodAndBeverageDetails.calorieCount'), _dec34 = alias('itemData.foodAndBeverageDetails.ingredients'), _dec35 = alias('itemData.isTaxable'), _dec36 = alias('version'), _dec37 = alias('itemData.channelIntegrations'), _dec38 = alias('itemData.locationOverrides'), _dec39 = computed('variations', 'variations.@each.{priceMoney,isVariablePriced}', 'subunits', function () {
  return this.getDisplayPriceRangeForUnits(this.subunits);
}), _dec40 = equal('variations.length', 1), _dec41 = reads('images.firstObject', function () {
  return this.images.firstObject;
}), _dec42 = computed('images', 'variations.@each.images', function () {
  // Gather and dedupe the images from the item and its variations
  const variationImages = this.variations.toArray().flatMap(variation => variation.images.toArray());
  return [...this.images.toArray(), ...variationImages].reduce((unique, current) => {
    const existing = unique.find(image => image.id === current.id);
    if (!existing) {
      return [...unique, current];
    } else {
      return unique;
    }
  }, []);
}), _dec43 = computed('variations.@each.{isDeleted,isPlaceholder,ordinal,stockable}', 'userSubscriptions.canUseAdvancedInventory', 'features', function () {
  let variations = this.variations;
  if (!this.userSubscriptions.canUseAdvancedInventory) {
    variations = variations.filter(variation => variation.stockable);
  }
  return A(variations.filter(variation => !variation.isDeleted)).sortBy('ordinal');
}), _dec44 = alias('nonDeletedNonPlaceholderVariations'), _dec45 = computed('nonDeletedNonPlaceholderVariations.@each.{ordinal,sellable}', function () {
  return this.nonDeletedNonPlaceholderVariations.filterBy('sellable').sortBy('ordinal');
}), _dec46 = computed('_subunits', 'absentAtLocationIds', 'presentAtAllLocations', 'presentAtLocationIds'), _dec47 = computed('variations.@each.subscriptionPlanIds', function () {
  return this.variations.reduce((list, current) => {
    // Create a unique set.
    return [...new Set([...list, ...current.subscriptionPlanIds.toArray()])];
  }, []);
}), _class2 = (_class3 = class _class2 extends CatalogObject.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "type", _descriptor5, this);
    _initializerDefineProperty(this, "itemData", _descriptor6, this);
    _initializerDefineProperty(this, "variations", _descriptor7, this);
    _initializerDefineProperty(this, "event", _descriptor8, this);
    _initializerDefineProperty(this, "taxes", _descriptor9, this);
    _initializerDefineProperty(this, "images", _descriptor10, this);
    _initializerDefineProperty(this, "name", _descriptor11, this);
    _initializerDefineProperty(this, "sortName", _descriptor12, this);
    _initializerDefineProperty(this, "description", _descriptor13, this);
    _initializerDefineProperty(this, "productType", _descriptor14, this);
    _initializerDefineProperty(this, "modifierListInfo", _descriptor15, this);
    _initializerDefineProperty(this, "comboSlots", _descriptor16, this);
    _initializerDefineProperty(this, "categories", _descriptor17, this);
    _initializerDefineProperty(this, "isAvailableOnline", _descriptor18, this);
    _initializerDefineProperty(this, "ecomBuyButtonText", _descriptor19, this);
    _initializerDefineProperty(this, "ecomAvailable", _descriptor20, this);
    _initializerDefineProperty(this, "ecomVisibility", _descriptor21, this);
    _initializerDefineProperty(this, "descriptionHtml", _descriptor22, this);
    _initializerDefineProperty(this, "descriptionPlaintext", _descriptor23, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor24, this);
    _initializerDefineProperty(this, "ecomAllowOrderItemQuantities", _descriptor25, this);
    _initializerDefineProperty(this, "ecomOrderItemMaxQuantity", _descriptor26, this);
    _initializerDefineProperty(this, "isArchived", _descriptor27, this);
    _initializerDefineProperty(this, "isAlcoholic", _descriptor28, this);
    _initializerDefineProperty(this, "channels", _descriptor29, this);
    _initializerDefineProperty(this, "requiresSubscriptionToSell", _descriptor30, this);
    _initializerDefineProperty(this, "customShippingBoxId", _descriptor31, this);
    _initializerDefineProperty(this, "dietaryPreferences", _descriptor32, this);
    _initializerDefineProperty(this, "calorieCount", _descriptor33, this);
    _initializerDefineProperty(this, "ingredients", _descriptor34, this);
    _initializerDefineProperty(this, "isTaxable", _descriptor35, this);
    // Needed by ember-data-relationship-tracker to track relationships like images
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor36, this);
    _initializerDefineProperty(this, "channelIntegrations", _descriptor37, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor38, this);
    _initializerDefineProperty(this, "displayPriceRange", _descriptor39, this);
    _initializerDefineProperty(this, "isSinglePriced", _descriptor40, this);
    _initializerDefineProperty(this, "primaryImage", _descriptor41, this);
    _initializerDefineProperty(this, "itemImages", _descriptor42, this);
    _initializerDefineProperty(this, "nonDeletedNonPlaceholderVariations", _descriptor43, this);
    // TODO: incorporate connect/item-variations/compositions when that has been added in the backend
    // Leaving this as aliased until then to work with product-selector
    _initializerDefineProperty(this, "actualItemVariations", _descriptor44, this);
    _initializerDefineProperty(this, "sellableVariations", _descriptor45, this);
    _initializerDefineProperty(this, "subscriptionPlanIds", _descriptor46, this);
  }
  // EVENT TYPE
  get isEventType() {
    return this.productType === ItemTypeConnect.EVENT;
  }
  get isDonationType() {
    return this.productType === ItemTypeConnect.DONATION;
  }
  get isComboType() {
    return this.productType === ItemTypeConnect.COMBO;
  }

  // REPORTING CATEGORY
  get reportingCategory() {
    return this.itemData.reportingCategory;
  }

  // editing the category directly on the item model will also
  // update the categories array with the correct categories.
  set reportingCategory(newCategoryMembership) {
    const previousReportingCategoryId = this.itemData.reportingCategory?.categoryId;

    // if newCategoryMembership is set to null, then we set item.category to null and remove the previous category
    // from item.categories
    if (!newCategoryMembership) {
      set(this.itemData, 'reportingCategory', null);
      const newCategories = this.categories.filter(membership => membership.categoryId !== previousReportingCategoryId).toArray();
      this.categories = A(newCategories);
      return;
    }
    const hasCategoryChanged = newCategoryMembership?.categoryId !== previousReportingCategoryId;

    // if the new category is the same as the old one, we don't have to do anything
    if (!hasCategoryChanged) {
      return;
    }
    const existingMembershipForNewReportingCategory = this.categoryMembershipsByCategoryId[newCategoryMembership?.categoryId];

    // if a membership that matches newCategoryMembership.categoryId, doesn't exist we should add the new membership
    // to item.categories
    if (!existingMembershipForNewReportingCategory) {
      set(this.itemData, 'reportingCategory', newCategoryMembership);
      this.categories = A([...this.categories.toArray(), newCategoryMembership]);
      return;
    }

    // if it does exist, then we don't need to add it again to item.categories
    set(this.itemData, 'reportingCategory', existingMembershipForNewReportingCategory);
  }
  get categoryMembershipsByCategoryId() {
    const categoriesByCategoryIdMap = {};
    this.categories.forEach(membership => {
      categoriesByCategoryIdMap[membership.categoryId] = membership;
    });
    return categoriesByCategoryIdMap;
  }
  get subunits() {
    if (this._subunits) {
      return this._subunits;
    }
    const activeSubunits = itemSubunitsServiceActiveSubunits();
    if (this.presentAtAllLocations) {
      return activeSubunits.filter(subunit => {
        return !this.absentAtLocationIds.includes(subunit.token);
      });
    }
    const presentItemSubunitTokensSet = new Set(this.presentAtLocationIds.toArray());
    return activeSubunits.filter(unit => presentItemSubunitTokensSet.has(unit.token));
  }
  set subunits(value) {
    set(this, '_subunits', value);
  }
  getDisplayPriceRangeForUnits(units, filteredVariations = this.variations, measurementUnitsAbbreviations = new Set(), displayMeasurementUnitAbbreviation = false) {
    let max;
    let isVariable;
    let min = max = isVariable = null;
    const uniquePrices = new Set();
    filteredVariations.forEach(variation => {
      let hasUnitWithoutOverrides = isEmpty(units);
      const measurementUnitId = variation.measurementUnit ? variation.measurementUnit.id : '';
      units.forEach(unit => {
        const locationOverride = variation.getLocationOverride(unit.token);
        const priceOverride = locationOverride?.priceMoney;
        if (!isNone(priceOverride)) {
          if (isNone(priceOverride.currency)) {
            priceOverride.currency = this.userInfo.currencyCode;
          }
          const priceMoney = Money.create({
            amount: priceOverride.amount,
            currencyCode: priceOverride.currency
          });
          const poAmount = priceOverride.amount;
          if (isNone(poAmount)) {
            isVariable = true;
          } else {
            if (isNone(min) || poAmount < min.amount) {
              min = priceMoney;
            }
            if (isNone(max) || poAmount > max.amount) {
              max = priceMoney;
            }
            uniquePrices.add(`${poAmount}: ${measurementUnitId}`);
          }
        } else {
          hasUnitWithoutOverrides = true;
        }
      });
      if (hasUnitWithoutOverrides) {
        const price = variation.priceMoney ? variation.priceMoney.amount : undefined;
        if (!isVariable && variation.isVariablePriced) {
          isVariable = true;
          return;
        } else if (!price) {
          return;
        }
        if (isNone(min) || price < min.amount) {
          min = variation.priceMoney;
        }
        if (isNone(max) || price > max.amount) {
          max = variation.priceMoney;
        }
        uniquePrices.add(`${price}: ${measurementUnitId}`);
      }
    });

    // String selection
    if (isVariable) {
      return this.intl.t('items.displayPrice.variable');
    } else {
      if (measurementUnitsAbbreviations.size > 1) {
        return this.intl.t('items.displayPrice.numPrices', {
          count: uniquePrices.size
        });
      }
      const measurementUnitAbbreviation = displayMeasurementUnitAbbreviation ? measurementUnitsAbbreviations.values().next().value : '';
      if (!isNone(min)) {
        if (min.amount === max.amount) {
          return measurementUnitAbbreviation ? this.intl.t('items.displayPrice.exactMeasurement', {
            price: min.formatted,
            measurementUnitAbbreviation
          }) : min.formatted;
        } else {
          return measurementUnitAbbreviation ? this.intl.t('items.displayPrice.rangeMeasurement', {
            min: min.formatted,
            max: max.formatted,
            measurementUnitAbbreviation
          }) : this.intl.t('items.displayPrice.range', {
            min: min.formatted,
            max: max.formatted
          });
        }
      } else {
        return this.intl.t('items.displayPrice.free');
      }
    }
  }

  // These functions cascade location updating logic to related catalog objects.
  // Unlike the equivalent v3 functions, they do not include updating related item fees, or item modifier lists.
  addMerchantSubunit(merchantSubunit) {
    this.addMerchantSubunits([merchantSubunit]);
  }
  addMerchantSubunits(merchantSubunits) {
    if (isPresent(merchantSubunits)) {
      super.addMerchantSubunits(merchantSubunits);
      this.variations.rejectBy('isDeleted').forEach(variation => {
        variation.addMerchantSubunits(merchantSubunits);
      });
    }
  }

  // This function cascades the enabled property when you remove a subunit
  removeMerchantSubunit(subunitToken) {
    super.removeMerchantSubunit(subunitToken);
    this.variations.rejectBy('isDeleted').forEach(variation => variation.removeMerchantSubunit(subunitToken));
  }
  updateGloballyEnabledForRelationships(globallyEnabled) {
    this.variations.rejectBy('isDeleted').forEach(variation => {
      set(variation, 'globallyEnabled', globallyEnabled);
    });
  }
  static createDefault(store, options) {
    const newItem = store.createRecord('connect/item', {
      id: options.id,
      itemData: store.createFragment('connect/item/data', {
        ...options,
        categories: options.categories || []
      })
    });
    newItem.variations.addObject(ItemVariation.createDefault(store, newItem.idOrTempId()));
    return newItem;
  }
}, _defineProperty(_class3, "_modelNameForMigration", 'connect/item'), _class3), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "intl", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "userSubscriptions", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "features", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "userInfo", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "itemData", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "variations", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "event", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "taxes", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "images", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "sortName", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "description", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "productType", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "modifierListInfo", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "comboSlots", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "categories", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "isAvailableOnline", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "ecomBuyButtonText", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "ecomAvailable", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, "ecomVisibility", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, "descriptionHtml", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, "descriptionPlaintext", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, "kitchenName", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, "ecomAllowOrderItemQuantities", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, "ecomOrderItemMaxQuantity", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, "isArchived", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, "isAlcoholic", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, "channels", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, "requiresSubscriptionToSell", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, "customShippingBoxId", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class2.prototype, "dietaryPreferences", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class2.prototype, "calorieCount", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class2.prototype, "ingredients", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class2.prototype, "isTaxable", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class2.prototype, "relationshipTrackerVersion", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class2.prototype, "channelIntegrations", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class2.prototype, "locationOverrides", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class2.prototype, "displayPriceRange", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class2.prototype, "isSinglePriced", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class2.prototype, "primaryImage", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class2.prototype, "itemImages", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class2.prototype, "nonDeletedNonPlaceholderVariations", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class2.prototype, "actualItemVariations", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class2.prototype, "sellableVariations", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "subunits", [_dec46], Object.getOwnPropertyDescriptor(_class2.prototype, "subunits"), _class2.prototype), _descriptor46 = _applyDecoratedDescriptor(_class2.prototype, "subscriptionPlanIds", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };